import LoadPreviewWithDevice from "features/menu/components/LoadPreviewWithDevice";
import React, { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReloadOutlined } from "@ant-design/icons";
import { UTILS } from "utils";
import * as C from "config/Constants";
import { useParams } from "react-router-dom";
import AppOutlineButton from "components/ui/AppOutlineButton";

const IFRAME_W = 375;
const IFRAME_H = 812;
const PREVIEW_MAX_HEIGHT = 620;

function OrderingPagePreview({
  as = "page",
  state,
  updateState,
  menuId: menuIdProp,
  storeId,
  variant = "editor",
}) {
  const params = useParams();
  const { t } = useTranslation();
  const resolvedMenuId = menuIdProp || params?.menuId;

  const previewSlotRef = useRef(null);
  const [slotSize, setSlotSize] = useState({ w: 0, h: 0 });

  const getStorePreviewURL = () => {
    const userDetail = UTILS.getCurrentUser();

    if (
      !userDetail?.storeFrontURL ||
      !userDetail?.temporaryDomainName ||
      !resolvedMenuId
    ) {
      return "about:blank";
    }

    let href = `${userDetail.storeFrontURL?.replace("shop/", "")}${userDetail.temporaryDomainName}${C.PREVIEW}?menuId=${resolvedMenuId}`;

    if (storeId) {
      href += `&storeId=${encodeURIComponent(storeId)}`;
    }

    return href;
  };

  useLayoutEffect(() => {
    const el = previewSlotRef.current;
    if (!el) return;

    const measure = () => {
      const rect = el.getBoundingClientRect();
      setSlotSize({
        w: Math.floor(rect.width),
        h: Math.floor(rect.height),
      });
    };

    measure();

    const ro = new ResizeObserver(measure);
    ro.observe(el);

    return () => ro.disconnect();
  }, []);

  const refreshPreview = () => {
    updateState("random", (state?.random ?? 0) + 1);
  };

  const devicePreview = (
    <LoadPreviewWithDevice
      classes="block bg-white"
      random={state?.random ?? 0}
      width={IFRAME_W}
      height={IFRAME_H}
      getStorePreviewURL={getStorePreviewURL}
      color={variant === "store" ? "" : "gray"}
      scale={as === "page" ? 0.7 : 0.65}
      fitMaxWidth={slotSize.w || undefined}
      fitMaxHeight={slotSize.h || undefined}
      fitMaxScale={as === "page" ? 0.72 : 0.65}
    />
  );

  return (
    <div className="mx-auto flex h-full min-h-0 w-full flex-col gap-2 overflow-hidden rounded-lg border border-gray-200 bg-primary-light p-5">
      <div className="flex w-full flex-shrink-0 items-center justify-between gap-4">
        <h1 className="m-0 pt-0.5 text-17px font-bold">
          {t("Ordering Preview")}
        </h1>

        <AppOutlineButton type="primary" size="sm" onClick={refreshPreview}>
          <ReloadOutlined style={{ fontSize: "120%", marginRight: 5 }} />
          {t("Refresh")}
        </AppOutlineButton>
      </div>

      <div
        ref={previewSlotRef}
        className="flex min-h-0 flex-1 justify-center overflow-hidden"
        style={{ height: PREVIEW_MAX_HEIGHT, maxHeight: PREVIEW_MAX_HEIGHT }}
      >
        {devicePreview}
      </div>
    </div>
  );
}

export default OrderingPagePreview;